import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const updateProfilePicture = async (data) => {
  const { file } = data;
  const body = new FormData();
  body.append(
    "dados",
    `[{"alunoid":${_cookies.getItem("auth").user.alunoid}}]`
  );
  body.append("file", file);
  const res = await axios.middleware.post("/aluno.asmx/Altera_foto", body);
};

export const useUpdateProfilePicture = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: updateProfilePicture });
};
